<template>
  <div class="video-box">
    <div class="video-box-bg"></div>
    <div id="myflash" class="video-area" :class="{isC:isAnswer}" style=""></div>

    <div class="video-close" v-if="!isAnswer" @click="closeLive"></div>
    <div class="video-close-btn" v-if="isAnswer" @click="closeLive">我来回答</div>
  </div>
</template>

<script>
export default {
  props: {
    zhiboId: "",
    isAnswer: false
  },
  data() {
    return {
      player_single: ""
    };
  },
  mounted() {
    var that = this;
    var _player_width = "50vw"; //播放器宽
    var _player_height = "28.15vw"; //播放器高
    var posterImg = ""
    //移动端设置宽高，也可以自己定义宽高
    if (isIPad()) {
      var _player_width = document.body.clientWidth || window.innerWidth;
      var _player_height =
        document.documentElement.clientHeight || window.innerHeight;
      _player_width = parseInt(_player_width);
      _player_height = parseInt(_player_height);
      if (_player_width / _player_height < 1) {
        _player_height = (_player_width * 9) / 16;
      } else {
        _player_width = (_player_height * 16) / 9;
      }

      if (_player_width < 40 || _player_height < 30) {
        _player_width = 960;
        _player_height = 540;
      }
    }
    var isHttps = location.href.substr(0, 5) == "https" ? "true" : "false";
    var playerParasLive = {
      divId: "myflash",   /*播放器容器id，必填项*/
      w: _player_width,   /*播放器宽度，必填项*/
      h: _player_height,   /*播放器高度，必填项*/
      t: that.zhiboId,   /*台名称，比如cctv1,cctv13等，必填项*/
      isAutoPlay: "true",   /*是否自动播放，只有false为不自动播放，其它值为自动播放*/
      ruleVisible: "false",   /*是否显示时移尺子，默认true表示显示*/
      br: "",  /*设置默认码率*/
      posterImg: posterImg,   /*播放器前贴图片，如果需要传参 参数名必须是hdsPosterImg*/
      isLive4k: "false",  /*是否为4k播放器，true是4k,false不是*/
      isHttps: isHttps,  /*是否https视频，true是,false不是*/
      wmode: "opaque",   /*flash播放器的窗口模式，默认为opaque*/
      hasBarrage: "false",  /*是否有弹幕功能，默认false，false时不显示弹幕、不显示弹幕设置按钮、不显示弹幕开关、不访问弹幕接口和表情包配置接口e*/
      playerType: "live",   /*播放器类型，small表示小窗播放器*/
      webFullScreenOn: "false",   /*是否显示网页全屏按钮，默认true表示显示*/
      isLeftBottom: "false",  /*播放按钮是否在播放器左下角,为true表示是，false表示播放按钮在播放器中间*/
      others: ""   /*其它待定参数*/
    };

    // if (livePlayerObjs && JSON.stringify(livePlayerObjs) != "{}") {
    //   destroyLivePlayer("myflash")
    // }

    createLivePlayer(playerParasLive);



  },
  methods: {
    closeLive() {
      this.$emit("closeLive");
    },
  },
  beforeDestroy() {

  },
  created() { },
};
</script>

<style lang="scss" scoped>
.video-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10000;

  .video-box-bg {
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.6);
    position: absolute;
    top: 0;
    left: 0;
  }

  .video-area {
    width: 960px !important;
    height: 540px !important;
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.isC {
      width: 405px !important;
      height: 720px !important;
    }

  }

  .video-close {
    position: absolute;
    right: 50%;
    top: 50%;
    margin-top: -390px;
    margin-right: -590px;
    width: 42px;
    height: 42px;
    background: url("../assets/img/close-btn.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 1000;
  }

  .video-close-btn {
    position: absolute;
    right: 50%;
    top: 50%;
    margin-top: 370px;
    margin-right: -91px;
    width: 182px;
    height: 62px;
    line-height: 50px;
    font-size: 20px;
    color: #fff;
    background: url("../assets/img/btn-bg.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 1000;
  }
}
</style>